module.exports = __webpack_public_path__ + "static/media/chaubey.84d313a7.png";